import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { HubSpotFormBlock } from '../types';
import { LeadMagnetHubSpotForm } from '@/components/blocks/lead-magnet/LeadMagnetHubSpotForm';
import styles from './HubSpotForm.module.css';
interface HubSpotFormProps {
  block: HubSpotFormBlock;
  blockId: string;
}
export function HubSpotForm(t0) {
  const $ = _c(13);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.heading) {
    t1 = block.heading ? <h3 className={styles.heading}>{block.heading}</h3> : null;
    $[0] = block.heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== block.formId || $[3] !== block.portalId || $[4] !== block.region) {
    t2 = <LeadMagnetHubSpotForm formId={block.formId} portalId={block.portalId} region={block.region} lazy={true} />;
    $[2] = block.formId;
    $[3] = block.portalId;
    $[4] = block.region;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== block.formId || $[7] !== block.portalId || $[8] !== block.region || $[9] !== blockId || $[10] !== t1 || $[11] !== t2) {
    t3 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="hubspotForm" data-hs-portal-id={block.portalId} data-hs-form-id={block.formId} data-hs-region={block.region}>{t1}{t2}</div>;
    $[6] = block.formId;
    $[7] = block.portalId;
    $[8] = block.region;
    $[9] = blockId;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}